type SchoolYears = {
  startYear: string // id
  endYear: string // id
}

export const encodeSchoolYearsValue = (schoolYears: SchoolYears): string =>
  JSON.stringify(schoolYears)

export const decodeSchoolYearsValue = (value: string): SchoolYears =>
  JSON.parse(value)
